// extracted by mini-css-extract-plugin
export var heightForForm = "pickup-module--heightForForm--8+uAD";
export var mapInner = "pickup-module--mapInner--oRDSp";
export var mapOuter = "pickup-module--mapOuter--0SSU5";